export enum Navegacoes {
  DadosUsuario = 'dados-usuário',
  Contato = 'contato',
  Endereco = 'endereco'
}

export type TipoDadosDoFormulario = { [key: string]: any }
